import React from 'react';
import Config from '../config';
import { Button } from 'antd';
import MobileDetect from 'mobile-detect';

const authUrl = `https://appleid.apple.com/auth/authorize?client_id=${Config.thirdPartySignIn.apple}&redirect_uri=${Config.thirdPartySignIn.appleRedirectUrl}&response_type=code%20id_token&scope=name%20email&response_mode=form_post`

class AppleSigninButton extends React.Component {
    constructor(props) {
        super(props);

        this.handleOnSubmit = this.handleOnSubmit.bind(this);

    }

    handleOnSubmit = () => {
        console.log("Apple Sign In");
        window.location.assign(authUrl);
    }

    render() {
        const { isSubmitting } = this.props;
        const md = new MobileDetect(window.navigator.userAgent);
        const phone = md.phone();
        const tablet = md.tablet();

        Config.log(JSON.stringify(md));
        if (phone === "iPhone" || tablet === "iPad") {
            return (
                <div>

                    <Button
                        loading={isSubmitting}
                        onClick={this.handleOnSubmit}
                        className="apple"
                    >
                    </Button>

                </div>
            )
        }

        return null

    }

}

export default AppleSigninButton;
